/* eslint-disable react/jsx-indent-props */
/* eslint-disable indent */
/* eslint-disable max-len */
/* eslint-disable linebreak-style */
/* eslint-disable react/prefer-stateless-function */
/* eslint-disable react/jsx-sort-props */
import React, { useState, useEffect } from "react";
// import { Add as AddIcon } from "@mui/icons-material";
import {
  Grid,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider as MuiDivider,
} from "@mui/material";
import {
  AddBoxOutlined as AddIcon,
  Close as CloseIcon,
  Delete as DeleteIcon,
  Save as SaveIcon,
} from "@mui/icons-material";
import { spacing } from "@mui/system";
import { toast } from "react-toastify";
import styled from "@emotion/styled";

import AMMaterialTable from "./AMMatrialTable";
import {
  getNextSerial,
  saveSubFormRow,
  deleteSubFormRow,
} from "src/utils/amUtils";
import { getCaption } from "src/utils/dictionary";

const Divider = styled(MuiDivider)(spacing);
let x = 0;
function AMFooterTable({
  title,
  columns,
  tableData,
  setTableData,
  subFormState,
  setSubFormState,
  subFormErrors,
  validateSubFormData,
  editForm,
}) {
  const [openEditForm, setEditFOrmOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  //set nextSerial >> It'll be called after every add,update or delete row
  useEffect(() => {
    x++;
    console.log('setSubFormState({ id: "add",', x);
    setSubFormState({ id: "add", serial: getNextSerial(tableData) });
  }, [tableData]);

  const handleSubmit = async () => {
    let d = new Date();
    console.log(
      "handleSubmit",
      d.getTime() - new Date().getTime(),
      "handleSubmit 57",
      new Date()
    );
    if (
      isSubmitting ||
      (subFormErrors && Object.keys(subFormErrors).length > 0)
    ) {
      console.log(
        "handleSubmit",
        d.getTime() - new Date().getTime(),
        "handleSubmit return 62"
      );
      return;
    }

    console.log(
      "handleSubmit",
      d.getTime() - new Date().getTime(),
      "setIsSubmitting 66"
    );
    setIsSubmitting(true);
    console.log(
      "handleSubmit",
      d.getTime() - new Date().getTime(),
      "setIsSubmitting 68"
    );
    if (await validateSubFormData()) {
      try {
        console.log(
          "handleSubmit",
          d.getTime() - new Date().getTime(),
          "After validateSubFormData 71",
          new Date()
        );
        setTableData(saveSubFormRow(tableData, subFormState));
        console.log(
          "handleSubmit",
          d.getTime() - new Date().getTime(),
          "After setTableData 73",
          new Date()
        );
        setEditFOrmOpen(false);
        console.log(
          "handleSubmit",
          d.getTime() - new Date().getTime(),
          "After setEditFOrmOpen 75"
        );
      } catch (error) {
        toast.error(getCaption("system_error_try_later"));
      }
    }
    setIsSubmitting(false);
    console.log(
      "handleSubmit",
      d.getTime() - new Date().getTime(),
      "End handleSubmit 81"
    );
  };

  const handleSubmitAndNew = async (e) => {
    console.log("handleSubmitAndNew", isSubmitting, new Date());
    if (
      isSubmitting ||
      (subFormErrors && Object.keys(subFormErrors).length > 0)
    ) {
      console.log("aaaaaaaa", isSubmitting, new Date());
      return;
    }
    //setIsSubmitting(true);

    if (await validateSubFormData()) {
      console.log("after validateSubFormData", isSubmitting, new Date());
      try {
        setTableData(saveSubFormRow(tableData, subFormState));
      } catch (error) {
        toast.error(getCaption("system_error_try_later"));
      }
      console.log("after setTableData", isSubmitting, new Date());
    }

    setIsSubmitting(false);
  };

  const handleDeleteRow = () => {
    try {
      setTableData(deleteSubFormRow(tableData, subFormState));
      setEditFOrmOpen(false);
    } catch (error) {
      toast.error(getCaption("system_error_try_later"));
    }
  };
  return (
    <>
      {" "}
      <AMMaterialTable
        title={title}
        columns={columns}
        actions={[
          {
            icon: "edit",
            onClick: (event, rowData) => {
              setSubFormState({ ...subFormState, ...rowData });
              setEditFOrmOpen(true);
            },
          },
          {
            icon: "delete",
            onClick: (event, rowData) => {
              setTableData(deleteSubFormRow(tableData, rowData));
            },
            tooltip: getCaption("delete"),
          },
          {
            icon: () => (
              <div style={{ margin: "auto" }}>
                <AddIcon />
              </div>
            ),
            isFreeAction: true,
            onClick: (event, rowData) => {
              console.log(rowData);
              setSubFormState({
                id: "add",
                serial: getNextSerial(tableData),
              });
              setEditFOrmOpen(true);
            },
            tooltip: getCaption("click_add_new_row"),
          },
        ]}
        options={{
          search: true,
          columnsButton: true, // Flag for columns button that controls which column could be rendered
          grouping: false,
          emptyRowsWhenPaging: false,
          pageSize: 10,
          pageSizeOptions: [10, 20, 50],
          padding: "dense", // Padding of cells and rows
          margin: "dense", // margin of cells and rows
        }}
        data={tableData}
      />
      <Dialog
        open={openEditForm}
        onClose={() => setEditFOrmOpen(false)}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {subFormState && subFormState.id && subFormState.id !== "add"
            ? getCaption("edit_record")
            : getCaption("add_new_record")}{" "}
        </DialogTitle>
        <Divider my={2} />
        <DialogContent>{editForm}</DialogContent>
        <DialogActions>
          <Button
            mr={2}
            size="small"
            onClick={() => setEditFOrmOpen(false)}
            color="warning"
          >
            <CloseIcon />
            {getCaption("cancel")}
          </Button>
          {subFormState && subFormState.id && subFormState.id !== "add" && (
            <Button mr={2} size="small" onClick={handleDeleteRow} color="error">
              <DeleteIcon />
              {getCaption("delete")}
            </Button>
          )}
          <Button
            onClick={handleSubmit}
            disabled={Object.keys(subFormErrors).length > 0}
            color="primary"
          >
            <SaveIcon />
            {getCaption("submit")}
          </Button>
          <Button
            onClick={(e) => {
              setIsSubmitting(true);
              handleSubmitAndNew(e);
            }}
            disabled={isSubmitting || Object.keys(subFormErrors).length > 0}
            color="primary"
          >
            <SaveIcon />
            <AddIcon />
            {getCaption("submit_and_new")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default AMFooterTable;
